import styled, { css } from "styled-components";
import { Nav } from "react-bootstrap";

export const SidebarContainer = styled(Nav)<{ $expanded: boolean }>`
  width: 16.66666667%;
  transition: width 0.2s ease;

  .nav-elements {
    display: flex;
    flex-direction: column;
    padding-top: 0.5rem;
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  }

  .nav-link {
    color: var(--heeros-blue);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav-link > div {
    display: flex;
    align-items: center;
  }

  .nav-link.active {
    color: var(--heeros-blue) !important;
    border-radius: 10px;
    font-weight: bold;
  }

  .nav-item > .nav-link.active {
    border: 0;
    border-bottom: 3px solid var(--heeros-blue);
    border-radius: 0;
  }

  .nav-link > div > svg {
    margin-right: 0.5rem;
    width: 24px;
  }

  .nav-link > .star {
    margin-left: 0.5rem;
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .nav-link:hover .star {
    opacity: 1;
  }

  ${({ $expanded }) =>
    !$expanded &&
    css`
      width: 60px;

      .nav-elements {
        align-items: center;
        padding: 0;
      }

      .title {
        display: none;
      }

      .star {
        display: none;
      }

      .nav-link {
        padding: 0.5rem;

        > div > svg {
          margin-right: 0;
        }
      }
    `}
`;
